import { useEffect, useState } from "react";
import api from "../api/adminApi";
import AdminLayout from "./AdminLayout";

export default function VentasAdmin() {
  const [ventas, setVentas] = useState([]);

  useEffect(() => {
    api.get("/estadisticas")
      .then(res => setVentas(res.data.ultimasCompras || []))
      .catch(err => console.error(err));
  }, []);

  return (
    <AdminLayout>
      <h1>Ventas</h1>
      <table className="admin-table">
        <tbody>
          {ventas.map(v => (
            <tr key={v.id}>
              <td>{v.nombre_curso}</td>
              <td>{v.nombre_cliente}</td>
              <td>${v.monto}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminLayout>
  );
}

